export interface IPersonListingModel{
    Id?: number;
    AddressA?: string;
    AddressB?: string;
    AddressTitle?: string;
    CompanyName?: string;
    Email?: string;
    Fax?: string;
    FirstName?: string;
    Language?: number;
    LetterTitle?: string;
    MobilePhone?: string;
    Name?: string;
    PhoneBusiness?: string;
    PhoneNumber?: string;
    PhonePrivate?: string;
    Reference?: string;
    Color?: number;
}

export class PersonListingModel implements IPersonListingModel {
    Id?: number;
    AddressA?: string;
    AddressB?: string;
    AddressTitle?: string;
    CompanyName?: string;
    Email?: string;
    Fax?: string;
    FirstName?: string;
    Language?: number;
    LetterTitle?: string;
    MobilePhone?: string;
    Name?: string;
    PhoneBusiness?: string;
    PhoneNumber?: string;
    PhonePrivate?: string;
    Reference?: string;
    Color?: number;
    /**
     *
     */
    constructor(option: IPersonListingModel ={}) {
        Object.keys(option).forEach(key => this[key] = option[key])
    }
}